const CONFIG = {
	title: 'Zender Live Studio',
	targetsRoot: 'https://api.zender.tv/v1/targets',
	channelsRoot: 'https://api.zender.tv/v1/channels',
};

export default CONFIG;



// WEBPACK FOOTER //
// ./src/config/production.js